import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { DOData, DocdefDataVM, NJDocData, NJDocDefTemplate, NJReadDocDefTemplateLookup } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
@Component({
    selector: 'cy-dodrop-down',
    templateUrl: './dodrop-down.component.html',
    styleUrls: ['./dodrop-down.component.css']
})
export class DodropDownComponent implements OnInit {
    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup>
    @Input() lstDocData: NJDocData
    @Input() customParameters: any
    @Input() skipPostDocDefData: boolean;
    private _docData: NJDocData;
    @Input() set DocData(doData: NJDocData) {
        this._docData = doData;
        this.onSelect(+this._docData.dataValue);
    }
    get DocData(): NJDocData {
        return this._docData;
    }
    @Input() LookupId: string
    @Input() public loaderKey: string;
    @Input() isPopUpYesNo: string = "Neither";
    @Input() isValid: boolean;

    _isEnabled: boolean;
    get isEnabled(): boolean {
        return this._isEnabled;
    }
    @Input() set isEnabled(value: boolean) {
        this._isEnabled = value;
        this.isDisabled = !this._isEnabled;
    }

    //Keep API from firing if not needed.
    @Input() public ignorLabel: boolean = false;

    //use for cascading dropdown code field
    @Input() public hasEvent: boolean = false;
    @Output() clickBut: EventEmitter<DOData> = new EventEmitter<DOData>();
    @Output() clickEventStart: EventEmitter<DOData> = new EventEmitter<DOData>();
    @Output() keyDown: EventEmitter<DOData> = new EventEmitter<DOData>();
    @Output() dropDownAfterViewInit: EventEmitter<DodropDownComponent> = new EventEmitter<DodropDownComponent>();
    cascadingDropDown: boolean = false;
    lstAllDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup> = new Array<NJReadDocDefTemplateLookup>();
    selectedLookup: NJReadDocDefTemplateLookup = new NJReadDocDefTemplateLookup
    _selectedLookupValue: string
    public set selectedLookupValue(value: any) {
        this._selectedLookupValue = value;
        this.onSelectItem(value);
    }
    public get selectedLookupValue(): any {
        if (this._selectedLookupValue == undefined)
            return "0"
        else
            return this._selectedLookupValue;
    }

    ItemSelectedLookupId: number;
    errorMessage: string;
    isDisabled: boolean = false;
    isDirty: boolean = false;
    isHidden: boolean = false;
    isUseButtons: boolean = false;
    isLabelHidden: boolean = false;
    inputStyles: any;
    LabelStylesText: any;
    StylesInput: any;
    dataSize: string;
    constructor(private data: DocDefPrimLibService, private ref: ChangeDetectorRef
    ) { }
    ngOnInit() {
        if (this.customParameters != null) {
            // This will disable the drop-down if Disable = 'True' in the Template
            if (this.customParameters['Disable'] != null)
                if (this.customParameters['Disable'] === 'True')
                    this.isEnabled = false;

            if (this.customParameters['secondLookup'] != null) {
                this.cascadingDropDown = true;
            }

            if (this.customParameters['isLabelHidden'] != null)
                if (this.customParameters['isLabelHidden'].toUpperCase() === "TRUE")
                    this.isLabelHidden = true;
            if (this.customParameters['isUseButtons'] != null)
                if (this.customParameters['isUseButtons'].toUpperCase() === "TRUE")
                    this.isUseButtons = true;
        }

        let lstDocDefTemplateLookupOrig: Array<NJReadDocDefTemplateLookup> = this.lstDocDefTemplateLookup;
        if (this.customParameters.default) {
            let def: NJReadDocDefTemplateLookup = new NJReadDocDefTemplateLookup();
            if (this.selectedLookup) {
                this.selectedLookup.lookupTypeId = 0;
            }
            def.lookupType = null;
            def.longDesc = this.customParameters.default;
            def.shortDesc = def.longDesc;
            def.active = "D";
            def.lookupId = 0;
            if (this.customParameters.default != 'useIsValid')
                this.isValid = true
            else {
                def.longDesc = "";
                def.shortDesc = def.longDesc
            }
            this.lstAllDocDefTemplateLookup.unshift(DodropDownComponent.createCopy(def));
        }
        for (let item of this.lstDocDefTemplateLookup) {
            if (item.active == 'Y' || item.active == 'D' || item.active == '1') {
                if (this.lstAllDocDefTemplateLookup.filter(x => x.lookupId === item.lookupId && x.lookupId_Par === item.lookupId_Par).length === 0) {
                    this.lstAllDocDefTemplateLookup.push(DodropDownComponent.createCopy(item));
                }
            }
        }
        if (this.cascadingDropDown)
            this.lstDocDefTemplateLookup = []; //this.lstAllDocDefTemplateLookup;
        else
            this.lstDocDefTemplateLookup = this.lstAllDocDefTemplateLookup;
        let findLookupId: number = 0;
        if (this.LookupId) {
            if (this.customParameters.secondLookup != null) {
                let curLookupId: number = +this.LookupId;
                let lstFindLookupType = this.lstAllDocDefTemplateLookup.filter(function (t: NJReadDocDefTemplateLookup) {
                    return t.lookupId == curLookupId;
                });
                if (lstFindLookupType.length > 0) {
                    findLookupId = lstFindLookupType[0].lookupTypeId;
                }
                this.lstDocDefTemplateLookup = this.lstDocDefTemplateLookup.filter(function (t: NJReadDocDefTemplateLookup) {
                    return t.lookupTypeId == findLookupId;
                });
            } else {
                for (var i = 0; i < this.lstDocDefTemplateLookup.length; i++) {
                    if (this.lstDocDefTemplateLookup[i].lookupId == +this.LookupId) {
                        this.selectedLookup = DodropDownComponent.createCopy(this.lstDocDefTemplateLookup[i]);
                    }
                }
            }
        } else {
            if (this.DocDefTemplate.tType == "DropDownChild") {
                if (lstDocDefTemplateLookupOrig.length > 0) {
                    this.selectedLookup = DodropDownComponent.createCopy(lstDocDefTemplateLookupOrig[0]);
                }
            } else {
                if (this.lstDocDefTemplateLookup.length > 0) {
                    this.selectedLookup = DodropDownComponent.createCopy(this.lstDocDefTemplateLookup[0]);
                }
            }
        }
        //if (this.customParameters['inputStyles'] != null) {
        //    let styles = this.data.replaceAll(this.customParameters['inputStyles'], "'", '"');
        //    this.inputStyles = JSON.parse(styles);
        //} else {
        //    this.inputStyles = { 'width': 'auto' };
        //}
        if (this.customParameters['LabelStylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['LabelStylesText'], "'", '"');
            this.LabelStylesText = JSON.parse(styles);
        }
        if (this.customParameters['StylesInput'] != null) {
            let styles = this.data.replaceAll(this.customParameters['StylesInput'], "'", '"');
            this.StylesInput = JSON.parse(styles);
        }
        if (this.customParameters['hasEvent'] != null) {
            this.hasEvent = true;
        }
        this.setHiddenStatus();
        this.setReadonlyStatus(this.isEnabled);
        if (this.customParameters['dataSize'] != null) {
            this.dataSize = this.customParameters['dataSize'];
        }
        //this._selectedLookupValue = this.selectedLookup.lookupId;
    }
    static createCopy(objectToCopy: NJReadDocDefTemplateLookup): NJReadDocDefTemplateLookup {
        if (objectToCopy)
            return (JSON.parse(JSON.stringify(objectToCopy)));
        else return undefined;
    }
    isNumber(value: string | number): boolean {
        return !isNaN(Number(value.toString()));
    }
    onKeydown(e: KeyboardEvent): void {

        //if (this.hasEvent) {
        var selectedLookup: number = -1;;
        var upperKey = e.key.toLocaleUpperCase();
        for (var i = 0; i < this.lstDocDefTemplateLookup.length; i++) {
            var firstChar = this.lstDocDefTemplateLookup[i].longDesc.substring(0, 1).toUpperCase();
            if (upperKey == firstChar) {
                selectedLookup = this.lstDocDefTemplateLookup[i].lookupId;
                this.selectedLookup = DodropDownComponent.createCopy(this.lstDocDefTemplateLookup[i]);
                this.LookupId = this.selectedLookup.lookupId.toString();
                this.onSelectItem(this.LookupId);
                break;
            }
        }
        if (selectedLookup > 0) {
            this.ref.detectChanges();           
        }
        //}

    }
    onSelectItem(LookupId): void {
        this.LookupId = LookupId;
        this.onSelect(+this.LookupId);
        this.fireEventBefore();
        this.onBlurDD();
    }

    fireEventBefore() {
        if (this.hasEvent) {
            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = this.DocData;
            let findLookupType: string = "";
            let curLookupId: number = +this.LookupId;
            let lstFindLookupType = this.lstDocDefTemplateLookup.filter(function (t: NJReadDocDefTemplateLookup) {
                return t.lookupId == curLookupId;
            });
            if (lstFindLookupType.length > 0) {
                findLookupType = lstFindLookupType[0].lookupType;
            }
            DOMessage.lstDocDefTemplateLookup = lstFindLookupType;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            DOMessage.isEnabled = this.isDisabled;
            this.clickEventStart.emit(DOMessage);
        }
    }

    getLstDocDefTemplateLookup(): Array<NJReadDocDefTemplateLookup> {
        var strBlank = " ";
        var strBlankHTML = "&nbsp;";
        let ret: Array<NJReadDocDefTemplateLookup>;
        if (this.isUseButtons) {
            ret = this.lstDocDefTemplateLookup.filter((template: NJReadDocDefTemplateLookup) => {
                return (template.active == 'Y' || template.active == 'D' || template.active == '1')
            });
        } else {
            ret = this.lstDocDefTemplateLookup.filter((template: NJReadDocDefTemplateLookup) => {
                return (template.active == 'Y' || template.active == '1');
            });
        }
        return ret;
    }
    onSelect(LookupId: number) {
        // if multiple lookups are present select the one that is consistent with the input lookupID
        // Don't thing we need this. From here-----------------------------------------------------------------------------------------------------|
        if (this.cascadingDropDown) {                                                                                                           //-|
            let selectedLookup: NJReadDocDefTemplateLookup = this.lstAllDocDefTemplateLookup.filter(function (t: NJReadDocDefTemplateLookup) {  //-|
                return LookupId == t.lookupId                                                                                                   //-|
            })[0];                                                                                                                              //-|
            this.lstDocDefTemplateLookup = this.lstAllDocDefTemplateLookup.filter(function (t: NJReadDocDefTemplateLookup) {                    //-|
                return selectedLookup.lookupTypeId == t.lookupTypeId                                                                            //-|
            });                                                                                                                                 //-|
        }                                                                                                                                       //-|
        // Don't thing we need this. Down to here -------------------------------------------------------------------------------------------------|
        if (this.lstDocDefTemplateLookup.length > 0) {
            this.selectedLookup = DodropDownComponent.createCopy(this.lstDocDefTemplateLookup[0]);
            for (var i = 0; i < this.lstDocDefTemplateLookup.length; i++) {
                if (this.lstDocDefTemplateLookup[i].lookupId == LookupId) {
                    this.selectedLookup = DodropDownComponent.createCopy(this.lstDocDefTemplateLookup[i]);
                    if (this.DocData.dataValue)
                        this.isDirty = this.DocData.dataValue.trim() == LookupId.toString() ? false : true
                    else
                        this.isDirty = true;
                    this.DocData.dataValue = LookupId.toString();
                }
            }
            this.LookupId = this.selectedLookup.lookupId.toString();
        }
        else {
            this.LookupId = "0";
            var blankTemplate = new NJReadDocDefTemplateLookup();
            this.lstAllDocDefTemplateLookup.push(blankTemplate);
            this.selectedLookup = DodropDownComponent.createCopy(this.lstDocDefTemplateLookup[0]);
        }

    }
    fireEvent(): void {
        if (this.hasEvent) {
            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = this.DocData;
            let findLookupType: string = "";
            let curLookupId: number = +this.LookupId;
            let lstFindLookupType = this.lstDocDefTemplateLookup.filter(function (t: NJReadDocDefTemplateLookup) {
                return t.lookupId == curLookupId;
            });
            if (lstFindLookupType.length > 0) {
                findLookupType = lstFindLookupType[0].lookupType;
            }
            DOMessage.lstDocDefTemplateLookup = lstFindLookupType;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            DOMessage.isEnabled = this.isDisabled;
            this.clickBut.emit(DOMessage);
        }
    }
    onBlurDD() {
        if (!this.isPopUpYesNo)
            this.isDirty = false;

        //Made this change to bypass the PostDocDefData calls in AddNewYouth controls
        if ((this.customParameters.skipPostDocDefData == "True" || this.skipPostDocDefData == true) && this.customParameters.DontskipPostDocDefData != "True") {
            return this.onSaveComplete(this);
        }
        else {
            if (this.isDirty) {
                let lstDocData: DocdefDataVM = new DocdefDataVM();
                lstDocData.docdata.push(this.DocData);
                lstDocData.loaderKey = this.loaderKey;
                var _this = this;
                this.data.saveDocDefData(lstDocData)
                    .subscribe(function () {
                        _this.isDirty = false;
                        return _this.onSaveComplete(_this);
                    }, function (error) {
                        return _this.errorMessage = error;
                    });
            } else {
                this.fireEvent();
            }
        }

    }
    evCallBackWhenClean: DOData;
    evComponent: any
    CallBackWhenClean(ev, component) {
        this.evCallBackWhenClean = ev;
        this.evComponent = component;
    }
    onSaveComplete(_this: any) {
        if (_this.evCallBackWhenClean) {
            let ev = DocDefPrimLibService.createNew(this.evCallBackWhenClean);
            this.evComponent.onClickButton(ev);
            this.evCallBackWhenClean = null;
        } else {
            this.fireEvent();
        }
    }
    setCascadingDDByLookupId(findLookupId: number, resetSelection: boolean = true, SelectedDesc: string = "", AutoCascading: boolean = true, showAll: boolean = false, overrideSorting: boolean = true, allowEmptyItem: boolean = false): void {
        if (showAll) {
            this.lstDocDefTemplateLookup = this.lstAllDocDefTemplateLookup;
        } else {

            //**********************************
            // Show all the children that 
            // matches their parent id
            //**********************************
            this.lstDocDefTemplateLookup = this.lstAllDocDefTemplateLookup.filter(function (t: NJReadDocDefTemplateLookup) {
                return t.lookupId_Par == findLookupId;
            });
        }

        if (overrideSorting)
            this.lstDocDefTemplateLookup = this.lstDocDefTemplateLookup.sort((a, b) => a.longDesc > b.longDesc ? 1 : -1);
        else
            this.lstDocDefTemplateLookup = this.lstDocDefTemplateLookup.sort((a, b) => a.sortOrder - b.sortOrder);


        if (this.customParameters['SelectAll'] != null) {
            let defAll: NJReadDocDefTemplateLookup = new NJReadDocDefTemplateLookup();
            this.selectedLookup.longDesc = "";
            defAll.lookupTypeId = findLookupId;
            defAll.longDesc = "All";
            defAll.shortDesc = "All";
            defAll.active = "Y";
            defAll.lookupId = 99999;
            this.lstDocDefTemplateLookup.unshift(DodropDownComponent.createCopy(defAll));
        }
        if (allowEmptyItem) {
            let defEmptyItem: NJReadDocDefTemplateLookup = new NJReadDocDefTemplateLookup();
            this.selectedLookup.longDesc = "";
            defEmptyItem.lookupTypeId = findLookupId;
            defEmptyItem.longDesc = "";
            defEmptyItem.shortDesc = "";
            defEmptyItem.active = "Y";
            defEmptyItem.lookupId = -1;
            this.lstDocDefTemplateLookup.unshift(DodropDownComponent.createCopy(defEmptyItem));
            this.selectedLookup = defEmptyItem;
            this.selectedLookup.lookupId_Par = findLookupId;
            this.selectedLookup.longDesc = "";
            this.selectedLookup.lookupId = -1;
            this.DocData.dataValue = "-1";
        }

        if (resetSelection) {
            // clear the new cascading drop down selection
            this.selectedLookup.lookupId_Par = findLookupId;
            // maintain default selection
            this.selectedLookup.longDesc = SelectedDesc;
            this.selectedLookup.lookupId = -1;
            this.DocData.dataValue = "-1";
        }
        else {
            this.selectedLookup.lookupId_Par = findLookupId;
            this.selectedLookup.longDesc = SelectedDesc;
        }
        if (AutoCascading) {
            this.fireEvent();
            this.isDirty = true;
            this.onBlurDD();
        }
        this.ref.detectChanges();
    }


    setCascadingDD(findLookupId: number, resetSelection: boolean = true, SelectedDesc: string = ""): void {
        this.lstDocDefTemplateLookup = this.lstAllDocDefTemplateLookup.filter(function (t: NJReadDocDefTemplateLookup) {
            return t.lookupTypeId == findLookupId;
        });

        //this.lstDocDefTemplateLookup = this.lstDocDefTemplateLookup.sort((a, b) => a.longDesc > b.longDesc ? 1 : -1);

        if (this.customParameters['SelectAll'] != null) {
            let defAll: NJReadDocDefTemplateLookup = new NJReadDocDefTemplateLookup();
            this.selectedLookup.longDesc = "";
            defAll.lookupTypeId = findLookupId;
            defAll.longDesc = "All";
            defAll.shortDesc = "All";
            defAll.active = "Y";
            defAll.lookupId = 1;
            this.lstDocDefTemplateLookup.unshift(DodropDownComponent.createCopy(defAll));
        }

        if (resetSelection) {
            // clear the new cascading drop down selection
            this.selectedLookup.lookupTypeId = findLookupId;
            this.selectedLookup.longDesc = "";
        }
        else {
            this.selectedLookup.lookupTypeId = findLookupId;
            this.selectedLookup.longDesc = SelectedDesc;
        }

    }

    labelClass(): string {
        if (this.customParameters['LabelWidth'] == null) {
            return "col-12";
        } else {
            return this.customParameters['LabelWidth'];
        }
    }
    labelDivClass(): string {
        if (this.customParameters['LabelDivClass'] == null) {
            return "";
        } else {
            return this.customParameters['LabelDivClass'];
        }
    }
    inputWidth(): string {
        if (this.isUseButtons) {
            if (this.customParameters['InputWidth'] == null) {
                return "dropdown col-md-6 col-sm-6";
            } else {
                let dd: string = this.customParameters['InputWidth'].toString().trim();
                if (!(dd == 'dropdown' || dd.includes('dropdown ')) || dd.includes(' dropdown') || dd.includes(' dropdown '))
                    return this.customParameters['InputWidth'] + ' dropdown'
                else
                    return this.customParameters['InputWidth'];
            }
        } else {
            if (this.customParameters['InputWidth'] == null) {
                return "col-md-6 col-sm-6";
            } else {

                return this.customParameters['InputWidth'];
            }
        }
    }

    getInputStyle(): object {
        //if (this.customParameters['inputStyles'] != null) {
        //    let styles = this.data.replaceAll(this.customParameters['inputStyles'], "'", '"');
        //    this.inputStyles = JSON.parse(styles);
        //} else {
        //    this.inputStyles = { 'width': 'auto' };
        //}
        if (this.customParameters['inputStyles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['inputStyles'], "'", '"');
            this.inputStyles = JSON.parse(styles);
            if (this.isValid)
                //if (this.RowSelected) {
                //    if (this.RowSelected['background-color'] == "lightsteelblue") {
                //        this.TextBoxStyle['background-color'] = "lightsteelblue";
                //        return this.TextBoxStyle;
                //    }
                //}
                //else if (this.isReadOnly == true) {
                //    this.TextBoxStyle['background-color'] = "white";
                //    return this.TextBoxStyle;
                //}
                //else {
                return this.inputStyles;
            //}
            else {
                this.inputStyles['background-color'] = "lightpink";
                return this.inputStyles;
            }
        }
        else {
            if (this.isValid)
                return null
            else
                return { "background-color": "lightpink" };
        }
    }

    getMenuStyles(): object {
        if (this.customParameters['menuStyles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['menuStyles'], "'", '"');
            //if (this.isValid)
            //if (this.RowSelected) {
            //    if (this.RowSelected['background-color'] == "lightsteelblue") {
            //        this.TextBoxStyle['background-color'] = "lightsteelblue";
            //        return this.TextBoxStyle;
            //    }
            //}
            //else if (this.isReadOnly == true) {
            //    this.TextBoxStyle['background-color'] = "white";
            //    return this.TextBoxStyle;
            //}
            //else {
            return JSON.parse(styles);
            //}
            //else {
            //    this.inputStyles['background-color'] = "lightpink";
            //    return this.inputStyles;
            //}
        }
        else {
            //if (this.isValid)
            return null
            //else
            //   return { "background-color": "lightpink" };
        }
    }

    getOptionStyles(): object {
        if (this.customParameters['optionStyles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['optionStyles'], "'", '"');
            //if (this.isValid)
            //if (this.RowSelected) {
            //    if (this.RowSelected['background-color'] == "lightsteelblue") {
            //        this.TextBoxStyle['background-color'] = "lightsteelblue";
            //        return this.TextBoxStyle;
            //    }
            //}
            //else if (this.isReadOnly == true) {
            //    this.TextBoxStyle['background-color'] = "white";
            //    return this.TextBoxStyle;
            //}
            //else {
            return JSON.parse(styles);
            //}
            //else {
            //    this.inputStyles['background-color'] = "lightpink";
            //    return this.inputStyles;
            //}
        }
        else {
            //if (this.isValid)
            return null
            //else
            //   return { "background-color": "lightpink" };
        }
    }

    IsFormGroup() {
        let theClass: string = "";
        if (this.customParameters['Class'] != null) {
            theClass += this.customParameters['Class'];
        }
        if (this.customParameters['FormGroupItem'] == 'Yes') {
            theClass += " " + "form-group";

        }
        else if (this.customParameters["LabelLeft"] == "Yes") {
            theClass += " " + "form-inline";
        }
        return theClass;
    }
    getClassButton() {
        let theClass: string = "";
        if (this.isUseButtons) {
            theClass = "dropdown-toggle btn btn-info";
            if (this.customParameters['ButtonClass'] != null) {
                theClass += " " + this.customParameters['ButtonClass'];
            }
        } else {
            theClass = "custom-select btn btn-info";
            if (this.customParameters['ButtonClass'] != null) {
                theClass += " " + this.customParameters['ButtonClass'];
            }
        }
        return theClass;
    }
    //dropdown-menu ng-class="{'disabled': isDisabled }"
    getClassDDItem(lookup: NJReadDocDefTemplateLookup): string {
        let ret: string = "";
        if (this.isUseButtons) {
            ret = "dropdown-item dditem";
            if (this.isDisabled)
                ret = ret + " disabled";
        } else {
            ret = "dropdown-item";
            if (lookup.lookupId == this.selectedLookup.lookupId)
                ret = "dropdown-item active";

            if (this.isDisabled || lookup.active == "D")
                ret = ret + " disabled";
        }
        return ret;
    }
    getStyleDDItem(lookup: NJReadDocDefTemplateLookup): string {
        let ret: string = "{ 'background-color': 'white', 'color': 'black', 'text-align': 'left' }";
        if ((lookup.lookupId == 0 &&
            (lookup.lookupType != 'PgmByName' && lookup.lookupType != 'PgmByTrackingElement' && lookup.lookupType != 'SecurityGroup'))
            || lookup.active == "D")
            ret = "{ 'background-color': 'white', 'color': 'black', 'text-align': 'left', 'visibility': 'hidden'}";
        ret = this.data.replaceAll(ret, "'", '"');
        return JSON.parse(ret);
    }
    getSelectedLookupDesc() {
        if (this.customParameters.ShowShortDashLongDesc == 'Yes' && this.selectedLookup.shortDesc != "") {
            return this.selectedLookup.shortDesc + " - " + this.selectedLookup.longDesc;
        } else {
            if (this.selectedLookup) {
                return this.selectedLookup.longDesc;
            }
        }
    }
    getLookupDesc(lookup: NJReadDocDefTemplateLookup) {
        if (this.customParameters.ShowShortDashLongDesc == 'Yes' && lookup.shortDesc != "") {
            return lookup.shortDesc + " - " + lookup.longDesc;
        } else
            return lookup.longDesc;
    }

    resetSelection = function (option: string = '') {
        let index = 0;
        if (option) {
            index = this.lstDocDefTemplateLookup.findIndex(function (item) {
                return (item.shortDesc == option)
            })
        }
        //this.onSelectItem(this.lstDocDefTemplateLookup[index].lookupId)
        this.selectedLookupValue = this.lstDocDefTemplateLookup[index].lookupId;
    }

    resetSelectionById = function (option: string = '') {
        let index = 0;
        if (option) {
            index = this.lstDocDefTemplateLookup.findIndex(function (item) {
                return (item.lookupId == option)
            })
            if (index == -1)
                index = 0;
        }
        this.selectedLookupValue = this.lstDocDefTemplateLookup[index].lookupId;
    }

    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["HiddenIfMissingSecCode"]) {
            this.data.checkIfCodeInUserSecurity(this.customParameters["HiddenIfMissingSecCode"], this.data.LoaderKey).subscribe((ret: boolean) => {
                if (ret) {
                    this.isHidden = false;
                }
                else {
                    this.isHidden = true;
                }
            });
        }
        else this.isHidden = false;
    }

    setReadonlyStatus(isEnabled: boolean) {
        if (this.customParameters.isReadOnly == 'Yes' || !isEnabled)
            this.isDisabled = true;
        //has a youth been selected when it's required
        else if (this.customParameters["DisabledIfMissingYouthId"]) {
        }
        //is the the required seccode in the user's credentials
        else if (this.customParameters["DisabledIfMissingSecCode"]) {
            this.data.checkIfCodeInUserSecurity(this.customParameters["DisabledIfMissingSecCode"], this.data.LoaderKey).subscribe((ret: boolean) => {
                if (ret) {
                    this.isDisabled = false;
                }
                else {
                    this.isDisabled = true;
                }
            });
        }
        else this.isDisabled = false;
    }

    removeDropDownData() {
        // remove the data
        this.lstDocDefTemplateLookup = this.lstAllDocDefTemplateLookup.filter(function (t: NJReadDocDefTemplateLookup) {
            return t.lookupId_Par == -1;
        });

    }
    ngAfterViewInit() {
        this.dropDownAfterViewInit.emit(this);
    }
}
